var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('register-users',{ref:"RegisterUsers"}),_c('show-users',{ref:"ShowUsers"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }